import { createTheme } from "@mui/material/styles";
// Self-host the exact Outfit weights the UI uses (previously loaded from Google
// Fonts in index.html). Each file uses unicode-range so browsers fetch only the
// glyph subset they need.
import "@fontsource/outfit/300.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import COLORS from "./colors";

const theme = createTheme({
  typography: {
    fontFamily: '"Outfit", sans-serif',
  },
  palette: {
    primary: {
      main: COLORS.primary,
      dark: COLORS.primaryDark,
    },
    secondary: {
      main: COLORS.secondary,
    },
    accent: {
      main: COLORS.accent,
    },
    background: {
      default: COLORS.background,
      paper: COLORS.white,
    },
    text: {
      primary: COLORS.text,
      secondary: COLORS.textSecondary,
    },
  },
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.primary,
          "& .MuiTableCell-root": {
            color: COLORS.white,
            fontWeight: 700,
            fontSize: "0.8rem",
            letterSpacing: "0.02em",
            whiteSpace: "nowrap",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:nth-of-type(even)": {
            backgroundColor: COLORS.surfaceMuted,
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root:hover": {
            backgroundColor: "#EAF1EC",
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: `1px solid ${COLORS.border}`,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${COLORS.border}`,
        },
      },
    },
  },
});

export default theme;
